<template>
  <div class="program">
    <div class="pass-button">
      <el-button :type="addPrimary==6?'primary':''" plain @click="handleCurrentNodeLabel(6)">初审</el-button>
      <el-button :type="addPrimary==7?'primary':''" plain  @click="handleCurrentNodeLabel(7)">复审</el-button>
      <!-- <el-button :type="addPrimary==8?'primary':''" plain @click="handleCurrentNodeLabel(8)">终审</el-button> -->
    </div>
    <cs-form label-width="90px" class="header-search-box" ref="validForm" form-width="100%" :inline="true"
        :form="searchParams"
        :formData="searchData"
        :form-col="searchFormCol">
      <template slot="form_time">
        <el-date-picker type="datetimerange" v-model="time"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>
      <template slot="auditState">
        <el-select v-model="auditState" placeholder="请选择状态"
          @change="auditStateSelectChange">
          <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template slot="search">
        <el-button class="btn-margin" size="small" type="primary" @click="currentPageHandler(1)">查询</el-button>
        <el-button size="small" @click="resetHandle('validForm')">重置</el-button>
      </template>
    </cs-form>
    <div class="pass-button" v-if="addPrimary!=8">
      <el-button @click="handleSubmitPass(1)">批量通过</el-button>
      <el-button @click="handleSubmitUnPass(2)">批量不通过</el-button>
    </div>
    <div class="table">
      <div class="select-tip" v-if="multipleSelection.length>0">
        <p class="tip">已选中 <span class="num">{{multipleSelection.length}}</span> 条</p>
        <p class="clear" @click="clearHandle">清空</p>
      </div>
      <cs-table ref="multipleTable" :tableCols="tableCols" :tableData="tableData" :paginationOption="paginationOption"
        @row-dblclick="dbClick"
        @size-change="sizeChangeHandler"
        @current-change="currentPageHandler"
        @selection-change="selectionChange">
        <template slot-scope="scope" slot="imgUrl">
          <div class="img">
            <el-image :src="scope.row.poster?scope.row.poster:''" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </template>
        <template slot-scope="scope" slot="name">
          <span class="table-name">{{scope.row.name}}</span>
          <br>
          <span class="table-id">ID：{{scope.row.id}}</span>
        </template>
        <template slot-scope="scope" slot="auditState">
          <span>{{scope.row.auditState|vodAuditState }}</span>
        </template>
        <template slot-scope="scope" slot="auditTime"> {{scope.row.auditTime|timeFormat}}</template>
      </cs-table>
    </div>
    <InsideDialog ref="insideDataDialog" :insideData="insideData" :isProgram="'programs'"
      :unApproved="unApproved"
      :approved="approved"
      @addSuccess="currentPageHandler(1)"/>
    <el-dialog title="不通过原因" v-if="dialogVisible" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-input type="textarea" v-model="unpassDesc" :rows="5" maxlength="100" show-word-limit
        placeholder="请输入100以内的字符内容">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="unpassHandle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryProgramSetsForAudit, auditProgramSet, fetchByResourceId } from '@/resource/api/audit'
import InsideDialog from './insideProgramSetDialog.vue'

export default {
  name: 'ProgramCollect',
  components: {
    InsideDialog
  },
  data () {
    return {
      dialogVisible: false,
      needAuditArr: null,
      unpassDesc: '',
      searchParams: { // 节目search表单
        name: '',
        startTime: '',
        endTime: '',
        timeFlag: 'updateTime',
        operator: '',
        auditState: 'AUDIT_ING,AUDIT_NO_PASS',
        limit: 20,
        offset: 1
      },
      time: '',
      auditState: '',
      approved: 'RE_AUDIT_ING', // 初、复、终审 通过状态
      unApproved: 'AUDIT_NO_PASS', // 初、复、终审 不通过状态
      addPrimary: 6,
      stateList: [
        { label: '全部', value: 'AUDIT_ING,AUDIT_NO_PASS' },
        { label: '待初审', value: 'AUDIT_ING' },
        { label: '初审驳回', value: 'AUDIT_NO_PASS' }
      ],
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableCols: [ // 节目COLS
        { type: 'selection', width: 55 },
        { prop: 'imgUrl', label: '封面图', type: 'slot' },
        { prop: 'name', label: '名称', type: 'slot' },
        { prop: 'createBy', label: '提交用户' },
        { prop: 'auditTime', label: '提交时间', type: 'slot', sortable: true },
        { prop: 'auditState', label: '状态', type: 'slot' },
        {
          prop: 'control',
          label: '操作',
          type: 'spbtn',
          openTooltip: true,
          hideTitle: true,
          groups: [
            {
              icon: 'icon-shenhe-on',
              isShow: function (row) {
                if (row.auditState == 'AUDIT_ING' || row.auditState == 'UNIFORM_AUDIT_PASS' || row.auditState == 'UNIFORM_AUDIT_NO_PASS' || row.auditState == 'RE_AUDIT_ING') { // row.auditState == 'UNIFORM_AUDIT_NON' ||
                  return true
                } else {
                  return false
                }
              },

              title: '审核',
              clickHandler: this.detailInfo
            },
            {
              icon: 'icon-xiangxi',
              isShow: function (row) {
                if ((row.auditState == 'AUDIT_NO_PASS') || (row.auditState == 'RE_AUDIT_NO_PASS') || (row.auditState == 'UNIFORM_AUDIT_NO_PASS')) {
                  return true
                } else {
                  return false
                }
              },
              title: '查看原因',
              clickHandler: this.viewReason
            }
          ]
        }
      ],
      tableData: [],
      multipleSelection: [], // 节目选中数据
      paginationOption: {},
      insideData: {} // 详情 DATA
    }
  },
  mounted () {
    this.pageInit()
  },
  methods: {
    pageInit () {
      this.$refs.validForm.resetFields()
      this.$refs.multipleTable.clearSelection()
      this.searchParams.operator = this.$store.state.router.createBySuffix
      this.paginationOption['page-size'] = this.$store.state.pageLimit
      this.searchParams.limit = this.$store.state.pageLimit
      this.currentPageHandler(1)
    },
    currentPageHandler (val) {
      this.searchParams.offset = val
      this.getData(this.searchParams)
    },
    sizeChangeHandler (val) {
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.getData(this.searchParams)
    },
    // 重置
    resetHandle (formName) {
      this.time = ''
      this.auditState = ''
      this.$refs[formName].resetFields()
    },
    // 节目选中数据
    selectionChange (rows) {
      this.multipleSelection = []
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.multipleSelection.push(row.id)
          }
        })
      }
    },
    handleCurrentNodeLabel (type) {
      this.$refs.validForm.resetFields()
      this.time = ''
      switch (type) {
        case 6:
          this.stateList = [
            { label: '全部', value: 'AUDIT_ING,AUDIT_NO_PASS' },
            { label: '待初审', value: 'AUDIT_ING' },
            { label: '初审驳回', value: 'AUDIT_NO_PASS' }
          ]
          this.searchParams.auditState = 'AUDIT_ING,AUDIT_NO_PASS'
          this.addPrimary = 6
          this.approved = 'RE_AUDIT_ING'
          this.unApproved = 'AUDIT_NO_PASS'
          break
        case 7:
          this.stateList = [
            { label: '全部', value: 'RE_AUDIT_ING,RE_AUDIT_NO_PASS,RE_AUDIT_PASS' },
            { label: '待复审', value: 'RE_AUDIT_ING' },
            { label: '复审通过', value: 'RE_AUDIT_PASS' },
            { label: '复审驳回', value: 'RE_AUDIT_NO_PASS' }
          ]
          this.searchParams.auditState = 'RE_AUDIT_ING,RE_AUDIT_NO_PASS'
          this.addPrimary = 7
          this.approved = 'RE_AUDIT_PASS'
          this.unApproved = 'RE_AUDIT_NO_PASS'
          break
        case 8:
          this.stateList = [
            { label: '待终审', value: 'UNIFORM_AUDIT_NON' },
            { label: '终审通过', value: 'UNIFORM_AUDIT_PASS' },
            { label: '终审未通过', value: 'UNIFORM_AUDIT_NO_PASS' }
          ]
          this.searchParams.auditState = 'UNIFORM_AUDIT_NON, UNIFORM_AUDIT_PASS, UNIFORM_AUDIT_NO_PASS'
          this.addPrimary = 8
          this.approved = ''
          this.unApproved = ''
          break
      }
      this.auditState = ''
      this.currentPageHandler(1)
    },
    // 加载数据
    getData (data) {
      const that = this
      data.startTime = this.time ? this.time[0] : this.time
      data.endTime = this.time ? this.time[1] : this.time
      queryProgramSetsForAudit(data).then((res) => {
        if (res && res.results) {
          that.tableData = res.results
          this.paginationOption = {
            ...this.paginationOption,
            'current-page': this.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    // 批量操作
    handleSubmitPass (passState) {
      var needAuditArr = []
      if (this.multipleSelection.length == 0) {
        this.$message('还没有选中内容')
      } else {
        needAuditArr = {
          ids: this.multipleSelection,
          auditState: this.approved,
          deleteFlag: 0,
          memo: '',
          operator: this.$store.state.router.updateBySuffix
        }
        this.handleSubmit(1, needAuditArr)
      }
    },
    // 批量操作审核通过
    handleSubmitUnPass (passState) {
      var needAuditArr = []
      if (this.multipleSelection.length == 0) {
        this.$message('还没有选中内容')
      } else {
        needAuditArr = {
          ids: this.multipleSelection,
          auditState: this.unApproved,
          deleteFlag: 0,
          memo: '',
          operator: this.$store.state.router.updateBySuffix
        }
        this.handleSubmit(2, needAuditArr)
      }
    },
    // 批量通过、不通过提交
    handleSubmit (passState, needAuditArr) {
      const tip = passState == 1 ? '批量通过审核' : '批量不通过审核'
      const content = passState == 1 ? '您确定要批量通过选中的内容吗?' : '您确定要批量不通过选中的内容吗？'
      this.$confirm(`${content}`, `${tip}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (passState == 1) {
          this.fetchAuditProgram(passState, needAuditArr)
        } else {
          this.dialogVisible = true
          this.needAuditArr = needAuditArr
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    unpassHandle () {
      if (this.unpassDesc) {
        this.needAuditArr.memo = this.unpassDesc
        this.fetchAuditProgram(2, this.needAuditArr)
      } else {
        this.$message({
          message: '请输入不通过原因',
          type: 'error'
        })
      }
    },
    fetchAuditProgram (passState, needAuditArr) {
      auditProgramSet(needAuditArr).then((res) => {
        if (res.code == '1') {
          if (passState == 1) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'success'
            })
          }
          this.dialogVisible = false
          this.currentPageHandler(1)
          this.unpassDesc = ''
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    auditStateSelectChange (row) {
      this.searchParams.auditState = row
    },
    // 查看原因
    viewReason (row) {
      // 1 初审 2 终审 3 复审
      const data = {
        recordType: this.addPrimary == 6 ? 1 : (this.addPrimary == 7 ? 3 : 2),
        resourceId: row.id,
        type: 1
      }
      fetchByResourceId(data).then((res) => {
        if (res.code == '1') {
          this.$alert(res.results[0].memo, '原因', {
            confirmButtonText: '知道了'
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    clearHandle () {
      this.$refs.multipleTable.clearSelection()
    },
    // 双击当前条目查看详情
    dbClick (row, column, event) {
      this.detailInfo(row)
    },
    // 查看详情
    detailInfo (row) {
      this.insideData = row
      this.$nextTick(() => {
        this.$refs.insideDataDialog.openDialog()
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.unpassDesc = ''
    }
  },
  computed: {
    searchData () {
      return [
        { prop: 'name', type: 'input', label: '名称：', placeholder: '请输入', clearable: true, labelWidth: '60px', col: [3, 3, 3] },
        {
          prop: 'form_time',
          label: '提交时间：',
          type: 'slot'
        },
        {
          prop: 'auditState',
          label: '状态：',
          type: 'slot',
          filterable: true,
          options: this.stateList,
          change: this.auditStateSelectChange
        },
        { prop: 'search', type: 'slot', label: '', col: [3, 3, 3] }
      ]
    }
  }
}
</script>
<style lang="less">
@import "../../../../assets/css/auditManage.less";
.img {
  display: inline-block;
  padding-right: 10px;
  vertical-align: top;
  width: 170px;
  text-align: center;
  .el-image {
    width: 100%;
    height: 116px;
    font-size: 120px;
    color: #ccc;
    text-align: center;
  }
}
</style>
